import {
  ReducerState,
  MainState,
  RentRecordInfo,
  storeName,
} from '@/redux/reducers/reservation/cancelReserve';
import { getAllChannelWithCache } from '@/api/cacheRequest';

import { ReserveCancelAction } from './constant';
import { createActionMiddleware } from './helper';

// getState函数覆写
const actionWrapper = createActionMiddleware<ReducerState>(storeName);

// 更新初始化状态
const setInitStatus = (isInit: boolean) => {
  return { type: ReserveCancelAction.setInitStatus, payload: isInit };
};

// 更新loading状态
export const setLoadingStatus: (isLoading: boolean) => void = (isLoading) => {
  return {
    type: ReserveCancelAction.setLoadingStatus,
    payload: isLoading,
  };
};

const getAllChannelList = () => {
  return async (dispatch) => {
    try {
      getAllChannelWithCache().then((res) => {
        if (res && res.data) {
          dispatch({
            type: ReserveCancelAction.setChannelList,
            payload: res.data,
          });
        }
      });
    } catch (e) {
      //
    }
  };
};

// 页面初始化
export const initPageState: (initFunc: () => Promise<MainState>) => void = (initFunc) => {
  return async (dispatch) => {
    try {
      // 未初始化状态
      dispatch({
        type: ReserveCancelAction.initDefaultState,
        payload: <MainState>{
          isInit: false,
          isLoading: true,
          rentRecordList: [],
        },
      });
      // 获取渠道列表
      dispatch(getAllChannelList());
      // 调用初始化方法
      const initState = await initFunc();
      // 设置初始化数据
      dispatch({ type: ReserveCancelAction.initDefaultState, payload: initState });
      dispatch(setInitStatus(true));
      dispatch(setLoadingStatus(false));
    } catch (_) {
      dispatch(setInitStatus(false));
    }
  };
};

// 房间信息修改
export const handleRecordItemChange: (
  indexId: string,
  updateValue: Partial<RentRecordInfo>,
) => void = (indexId, updateValue) => {
  return actionWrapper((dispatch, getState) => {
    const { rentRecordList } = getState();

    dispatch({
      type: ReserveCancelAction.setRentRecordList,
      payload: rentRecordList.map((item) => {
        if (item.indexId === indexId) {
          return {
            ...item,
            ...updateValue,
          };
        }
        return item;
      }),
    });
  });
};

// 获取全部状态
export const getMainState: (callback: (state: ReducerState) => void) => void = (callback) => {
  return actionWrapper((_, getState) => {
    try {
      callback(getState());
    } catch (e) {
      //
    }
  });
};
